<rx-applications-bookings-navigation
  [groupBookingsAvailable]="isShowCPLGroupBookingEnabled$ | async">
</rx-applications-bookings-navigation>
<div class="container">
  <router-outlet></router-outlet>
</div>
